const DrawerButton = () => {
  return (
    <div className="fixed top-4 right-4 z-30 lg:hidden">
      <label
        htmlFor="left-sidebar-drawer"
        className="btn btn-primary drawer-button lg:hidden"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
          className="inline-block h-5 w-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          ></path>
        </svg>
      </label>
    </div>
  );
};

export default DrawerButton;
